import { useMutation, useQueryClient } from "@tanstack/react-query";
import { shippingCostApi } from "../services/shippingCost.api";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  SHIPPING_COST_MESSAGES_ERROR,
  SHIPPING_COST_MESSAGES_SUCCESS,
} from "../constants/messages";

export const useEnableShippingCost = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => shippingCostApi.enable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(SHIPPING_COST_MESSAGES_ERROR.ENABLE_ERROR);
        return;
      }
      successNotification(SHIPPING_COST_MESSAGES_SUCCESS.ENABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["shipping-costs-filter"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-costs"] });
    },
    onError: () => {
      errorNotification(SHIPPING_COST_MESSAGES_ERROR.ENABLE_ERROR);
    },
  });
};

export const useDisableShippingCost = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => shippingCostApi.disable(id),
    onSuccess: (res) => {
      if (!res.ok) {
        errorNotification(SHIPPING_COST_MESSAGES_ERROR.DISABLE_ERROR);
        return;
      }
      successNotification(SHIPPING_COST_MESSAGES_SUCCESS.DISABLE_SUCCESS);
      queryClient.invalidateQueries({ queryKey: ["shipping-costs-filter"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-costs"] });
    },
    onError: () => {
      errorNotification(SHIPPING_COST_MESSAGES_ERROR.DISABLE_ERROR);
    },
  });
};
